import { pxToRem, remToPx } from '../utils';

export const borderRadius = {
  '0': '0', // 0px
  '4': '0.25rem', // 4px
  '8': '0.5rem', // 8px
  '16': '1rem', // 16px
  '40': '2.5rem', // 40px
  '100': '6.25rem', // 100px
  full: '9999px', // circle
  pxToRem,
  remToPx,
} as const;

export type BorderRadius = typeof borderRadius;
